import { colors } from '../../colors';
var input = {
  textColor: colors.slateGrey
};
export default input;